<template>
  <v-simple-table
      class="table-layout mt-4 active-code-table"
      style="height: calc(100vh - 280px) !important; overflow-y: auto !important;">
    <template v-slot:default>
      <thead style="background: rgb(93, 95, 239)">
        <tr>
          <th style="min-width: 20px">
            <v-checkbox
                hide-details
                class="table-layout-checkbox ma-0 pa-0"
                v-model="checkboxAll"
                @change="onChangeCheckboxAll"
            />
          </th>
          <th style="min-width: 30px">ID</th>
          <th>Tên mã</th>
          <th>Trạng thái mã</th>
          <th>Kiểu mã</th>
          <th>Ngày kích hoạt</th>
          <th>Ngày tạo mã</th>
          <th>SĐT kích hoạt</th>
          <th>SĐT đại lý</th>
          <th>Tên đại lý</th>
          <th>Người tạo</th>
          <th>Số lượng môn</th>
          <th>Thao tác</th>
        </tr>
      </thead>
      <template v-if="activeCodeList.length == 0">
        <tr class="v-data-table__empty-wrapper">
          <td colspan="12" style="height:60px">
            <div class="no-result text-center mt-2">
              <span>Không tìm thấy kết quả</span>
            </div>
          </td>
        </tr>
      </template>
      <template v-else v-for="activeCode in activeCodeList">
        <tbody class="bg-hover" :key="activeCode.id">
          <tr>
            <td>
              <v-checkbox
                  hide-details
                  class="table-layout-checkbox ma-0 pa-0"
                  v-model="activeCode.checkbox"
              />
            </td>
            <td>{{ activeCode.id }}</td>
            <td>
              <span
                  class="active-code-code font-weight-bold"
                  @click="clickDetailActiveCode(activeCode)">
                {{ activeCode.activeCode }}
              </span>
            </td>
            <td>
              <span :class="activeCode.status == 'active' ? 'status-active-code in-used'
                : activeCode.status == 'inactive' ? 'status-active-code not-in-used'
                : 'status-active-code active-code-pending'">
                {{ getStatusActiveCode(activeCode.status) }}
              </span>
            </td>
            <td>{{_.get(activeCode, 'type.name', '')}}</td>
            <td>
              {{_.get(activeCode, 'activationAt', '')}}
            </td>
            <td>{{_.get(activeCode, 'createdAt', '')}}</td>
            <td>{{_.get(activeCode, 'activationPhone', '')}}</td>
            <td>{{_.get(activeCode, 'agencyPhone', '')}}</td>
            <td>{{_.get(activeCode, 'agencyName', '')}}</td>
            <td>{{_.get(activeCode, 'staffName', '')}}</td>
            <td>{{_.get(activeCode, 'numberOfSubject', '')}}</td>
            <td>
              <v-tooltip bottom v-if="activeCode.status !== 'inactive'">
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="printActiveCode(activeCode)"
                    v-if="checkAuthorization('agency-admin_download') || checkAuthorization('agency-admin_read')"
                    class="mr-2"
                    icon small
                    color="blue"
                    v-on="on"
                  >
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                </template>
                <span>In mã kích hoạt</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </template>
  </v-simple-table>
</template>
<script>
import moment from "moment";
export default {
  props: {
    activeCodeList: {
      type: Array,
      default: () => []
    },
    statusActiveCodeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      checkboxAll: false
    }
  },
  methods: {
    clickDetailActiveCode(activeCode) {
      let routeData = this.$router.resolve({
        name: 'ActiveCodeDetail',
        params: {
          id: activeCode.id || 0
        },
        query: {
          activeCodeCustomerId: activeCode.activeCodeCustomerId || null
        }
      });
      window.open(routeData.href, '_blank')
    },
    getStatusActiveCode(statusCode) {
      let indexStatus = this.statusActiveCodeList.findIndex(item => item.code == statusCode);
      if (indexStatus > -1) {
        return this.statusActiveCodeList[indexStatus].name
      }
      return '';
    },
    onChangeCheckboxAll() {
      this.activeCodeList.forEach(activeCode => {
        const contactTemp = activeCode;
        contactTemp.checkbox = this.checkboxAll;
      });
      console.log('activeCodeList: ', this.activeCodeList)
    },
    printActiveCode(activeCode) {
      Bus.$emit('print-code-in-order', activeCode);
    }
  }
};
</script>

<style lang="css" scoped>
.v-data-table td {
  padding: 0 8px !important;
}
/deep/ tbody td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.status-active-code {
  padding: 5px 10px;
  font-weight: bold;
  border-radius: 12px;
  white-space: nowrap;
}
.in-used {
  border: 1px solid #59ac31;
  color: #59ac31;
  background-color: #f0f9eb;
}
.active-code-pending {
  border: 1px solid #ef4512;
  color: #ef4512;
  background-color: #f8e5d8;
}
.not-in-used {
  border: 1px solid #f51212;
  color: #f51212;
  background-color: #f8d2d2;
}
.active-code-code {
  cursor: pointer;
}
</style>